import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import { getSwapStatsMock } from '@/shared/mocks/widgets'
import { getMockedResponse } from '@/shared/lib/getMockedResponse'
import CONFIG from '@/app/config/config'
import b2bApiClient from '@/shared/api/b2b-client'

export class SwapApiService {
  constructor() {
    this.client = b2bApiClient.getClient()
    this.isMock = CONFIG.USE_MOCKS === 'true'
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async createSwapApp(appData) {
    try {
      const response = await this.client.post('/partners/swap/apps', appData, {
        headers: this._headers,
      })
      return response.data
    } catch (error) {
      console.error('Error creating swap app:', error)
      throw error
    }
  }

  async getSwapApps() {
    try {
      const response = await this.client.get(
        '/partners/swap/apps',
        null,
        this._headers
      )
      return response
    } catch (error) {
      console.error('Error getting swap apps:', error)
      throw error
    }
  }

  async getSwapStats(params) {
    if (this.isMock) {
      return getMockedResponse(getSwapStatsMock, 1000)
    }

    return await this.client.get('/partners/swap/stats', params, this._headers)
  }

  async deleteSwapApp(appName) {
    return await this.client.delete(`/partners/swap/apps/${appName}`, {
      headers: this._headers,
    })
  }

  async updateSwapApp(appName, requestData) {
    const response = await this.client.put(
      `/partners/swap/apps/${appName}`,
      requestData,
      { headers: this._headers }
    )
    return response.data
  }
}

export const swapApiService = new SwapApiService()
export default swapApiService
